export default "__VITE_ASSET__xoz$XdGl__"